import { useGoldConfig } from '@iheartjane/data-access/react-query';
import { shouldShowGold } from '@iheartjane/menu';

import { useSafeEcommApp } from '@jane/shared/providers';

export interface ShouldShowGoldProps {
  store?: {
    id?: string | number;
    state?: string | null;
  };
}

export const useShouldShowGold = (props?: ShouldShowGoldProps): boolean => {
  const { appMode } = useSafeEcommApp();
  const { data: goldConfig, isLoading: isLoadingGoldConfig } = useGoldConfig();

  return (
    shouldShowGold({
      appMode,
      goldConfig: goldConfig || null,
      state: props?.store?.state,
      storeId: props?.store?.id,
    }) && !isLoadingGoldConfig
  );
};
